/*
 * sessionKeys.js — WP-SPLIT
 *
 * sessionStorage keys that App.js needs to read *before* (or without) loading
 * the screen that owns them. Screens are loaded on demand now, so importing a
 * constant straight out of a screen file would drag that whole screen into the
 * first download again and undo the split. The screens import the key from
 * here and still re-export it, so nothing else had to change.
 */

// Where the ChatGPT consent page parks its address so a dropped session can
// bring the person back to it (WP-GPT).
export const CHATGPT_CONNECT_RETURN_KEY = 'chatgpt_connect_return_to';
